<template>
  <div v-if="!hasResultsSlot" class="mb-2 px-2 d-flex align-center">
    <v-text-field
      rounded solo dense hide-details="auto"
      color="grey" background-color="white"
      :clearable="clearable"
      :value="value"
      @input="inputChange"
      label="Search"
      prepend-inner-icon="mdi-magnify"
    />
    <slot name="extra_buttons" />
  </div>

  <div v-else class="d-flex flex-column">
    <div class="px-2 d-flex align-center">
      <v-text-field
        rounded solo dense
        color="grey"
        background-color="white"
        :clearable="clearable"
        :value="value"
        @input="inputChange"
        label="Search"
        hide-details="auto"
        prepend-inner-icon="mdi-magnify"
      />
      <slot name="extra_buttons" />
    </div>
    <div class="py-1">
      <slot name="results" />
    </div>
  </div>
</template>

<script>

export default {
  name: "SearchBar",

  props: {
    value: String,

    clearable: {
      type: Boolean,
      default: false,
    }, 

    debounce: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    timer: null,
  }),

  computed: {
    hasResultsSlot () {
      return !!this.$slots.results
    },
  },

  methods: {
    inputChange(newValue) {
      if (!this.debounce) {
        this.$emit('input', newValue)
      } else {
        clearTimeout(this.timer);

        this.timer = setTimeout(() => { 
          this.$emit('input', newValue)
        }, 375)
      }
    },
  },
}
</script>